document.querySelectorAll('.text-truncator').forEach(function(container) {
  const lines = container.innerText.split('\n');
  const newHTML = lines
    .map(line => {
      const parts = line.split(':');
      if (parts.length < 2) return ''; // skip if no key-value

      const key = parts[0].trim();
      const value = parts.slice(1).join(':').trim();

      return `
        <div class="spec-line">
          <span class="spec-key">${key}</span>
          <span class="spec-value">${value}</span>
        </div>
      `;
    })
    .join('');

  container.innerHTML = `<div class="specs-box">${newHTML}</div>`;
});



// document.addEventListener("DOMContentLoaded", function () {
//   const accordion = document.querySelector("accordion-default");
//   const details = accordion?.querySelector("details.accordion__section");
//   const summary = details?.querySelector("summary");
//   const body = details?.querySelector(".accordion__body");

//   if (details && summary && body) {
//     // Set default open state
//     details.setAttribute("open", "");
//     details.classList.add("is-active");
//     summary.setAttribute("aria-expanded", "true");
//     body.style.height = "auto";
//   }
// });



document.addEventListener("DOMContentLoaded", function () {
  const rte = document.querySelector(".accordion__body-inner .rte");
  if (!rte) return;

  const spans = rte.querySelectorAll("span");
  const container = document.createElement("div");
  container.className = "product-info-container";

  spans.forEach(span => {
    const text = span.textContent.trim();
    if (text.includes(":")) {
      const [label, value] = text.split(":").map(s => s.trim());
      const row = document.createElement("div");
      row.className = "product-info-row";

      const labelDiv = document.createElement("div");
      labelDiv.className = "product-label";
      labelDiv.textContent = label;

      const valueDiv = document.createElement("div");
      valueDiv.className = "product-value";
      valueDiv.textContent = value;

      row.appendChild(labelDiv);
      row.appendChild(valueDiv);
      container.appendChild(row);
    }
  });

  // Replace old content
  rte.innerHTML = "";
  rte.appendChild(container);
});





if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      this.performRecommendations();
    }

    performRecommendations() {
      const recommendations = this.querySelector('[data-recommendations]');
      if (!recommendations) return;

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const recommendationsHTML = html.querySelector('[data-recommendations]')?.innerHTML;

          if (!recommendationsHTML) return;

          // Unhide component
          this.classList.remove('hidden');

          // 🛠 Fix class removal (remove dot from class name)
          const cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
          if (cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove('cart-drawer-items__full');
          }

          recommendations.innerHTML = recommendationsHTML;

          // ✅ Initialize Swiper
          this.initSlider();

          // ✅ Re-init Quick Cart Drawer (if available)
          setTimeout(() => {
            const quickCart = document.querySelector("quick-cart-drawer");
            if (quickCart && typeof quickCart.init === "function") {
              quickCart.init();
            } else {
              this.querySelectorAll(".quick-cart-drawer__trigger").forEach(el => {
                el?.remove();
              });
            }
          }, 500);
        });
    }

    initSlider() {
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 16,
      });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}

document.addEventListener('DOMContentLoaded', function() {
    const addToCartButton = document.querySelector('.stickyaddcart');
    const qtyMinusBtn = document.querySelector('.qtyminus');
    const qtyPlusBtn = document.querySelector('.qtyplus');
    const qtyInput = document.querySelector('.qtyinput');

    if (qtyMinusBtn && qtyInput) {
        qtyMinusBtn.addEventListener('click', function() {
            let currentValue = parseInt(qtyInput.value);
            currentValue = isNaN(currentValue) || currentValue <= 1 ? 1 : currentValue - 1;
            qtyInput.value = currentValue;
        });
    }

    if (qtyPlusBtn && qtyInput) {
        qtyPlusBtn.addEventListener('click', function() {
            let currentValue = parseInt(qtyInput.value);
            qtyInput.value = isNaN(currentValue) ? 1 : currentValue + 1;
        });
    }

    if (addToCartButton) {
        addToCartButton.addEventListener('click', function() {
            const stickyBox = document.querySelector('.variantActive');
            if (!stickyBox) return;

            const hiddenInput = stickyBox.querySelector('input[name="stickyhidden"]');
            let variantId = hiddenInput ? hiddenInput.value : null;

            if (!variantId) {
                const firstOption = document.querySelector('.hiddenVariantWrapper option');
                variantId = firstOption ? firstOption.value : null;
                if (!variantId) {
                    console.log("No variants available");
                    return;
                }
            }

            const quantity = parseInt(document.querySelector('.qtyinput').value) || 1;
            const btn = this;
            btn.disabled = true;

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: quantity })
            })
            .then(response => response.json())
            .then(data => {
                console.log('Added to cart:', data);

                fetch(window.Shopify.routes.root + "?section_id=cart-icon-bubble")
                    .then(res => res.text())
                    .then(html => {
                        const doc = new DOMParser().parseFromString(html, 'text/html');
                        const bubble = document.querySelector('#cart-icon-bubble');
                        if (bubble) bubble.innerHTML = doc.querySelector('.shopify-section').innerHTML;
                    });

                fetch(window.Shopify.routes.root + "?section_id=cart-drawer")
                    .then(res => res.text())
                    .then(html => {
                        const doc = new DOMParser().parseFromString(html, 'text/html');
                        const drawer = document.querySelector('cart-drawer');
                        const newDrawer = doc.querySelector('cart-drawer');
                        if (drawer && newDrawer) {
                            drawer.innerHTML = newDrawer.innerHTML;
                            drawer.classList.remove('is-empty');
                            drawer.classList.add('is-visible');
                            document.body.classList.add('overflow-hidden');

                            setTimeout(() => document.querySelector('.drawer').classList.add('is-visible'), 100);
                        }
                    });
            })
            .catch(error => console.error('Error adding to cart:', error))
            .finally(() => btn.disabled = false);
        });
    }
});

document.body.addEventListener('click', function (e) {
  if (e.target.matches('.pl4-add-btn')) {
    const btn = e.target;
    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    const quantity = 1;
    btn.classList.add('loading');
    btn.style.pointerEvents = 'none';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(response => response.json())
      .then(data => {
        console.log('Added to cart:', data);

        fetch(`${window.Shopify.routes.root}?section_id=cart-icon-bubble`)
          .then(res => res.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const bubble = document.querySelector('#cart-icon-bubble');
            if (bubble && doc.querySelector('.shopify-section')) {
              bubble.innerHTML = doc.querySelector('.shopify-section').innerHTML;
            }
          });

        fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`)
          .then(res => res.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const drawer = document.querySelector('cart-drawer');
            const newDrawer = doc.querySelector('cart-drawer');
            if (drawer && newDrawer) {
              drawer.innerHTML = newDrawer.innerHTML;
              drawer.classList.remove('is-empty');
              drawer.classList.add('is-visible');
              document.body.classList.add('overflow-hidden');

              setTimeout(() => {
                const drawerContainer = document.querySelector('.drawer');
                if (drawerContainer) drawerContainer.classList.add('is-visible');
              }, 100);
            }
          });
      })
      .catch(error => console.error('Error:', error))
      .finally(() => {
        btn.classList.remove('loading');
        btn.style.pointerEvents = 'auto';
      });
  }
});



document.addEventListener('DOMContentLoaded', function() {
    const productFormSubmit = document.querySelector('.product-form__submit');
    const stickyBox = document.querySelector('.Zaadran-stickybox');

    if (productFormSubmit && stickyBox) {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    stickyBox.classList.add('hide');
                } else {
                    stickyBox.classList.remove('hide');
                }
            });
        }, { threshold: 0.1 });

        observer.observe(productFormSubmit);
    }
});


document.addEventListener("DOMContentLoaded", function () {
  const cartDrawer = document.querySelector('cart-drawer');
  const stickyBox = document.querySelector('.Zaadran-stickybox');

  if (!cartDrawer || !stickyBox) return;

  const observer = new MutationObserver(() => {
    if (cartDrawer.classList.contains('is-visible')) {
      stickyBox.style.display = 'none';
    } else {
      stickyBox.style.display = '';
    }
  });

  observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
});


